export const defaultHubspotRuleItem = {
    event_action: '',
    hubspot_event_name: '',
    hubspot_event_id: '',
    hubspot_properties_map: null,
};

export const defaultPropertyMapObject = {
    anima_parameter_name: '',
    hubspot_property_name: '',
};

export const hubspotRulesColumns = [
    {label: 'HubSpot event', prop: 'hubspot_event_name'},
    {label: 'Anima event', prop: 'event_action'},
];

export const eventColumns = [
    {label: 'Event name', prop: 'event_action'},
];
